<template>
  <v-app-bar app dense flat clipped-left>
    <v-toolbar-title class="mr-4">
      <span class="font-weight-bold">Android Game Account Deletion</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn text @click="handleLogout">Log out</v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { NOT_AUTHORIZED } from '../../config/events';

export default {
  methods: {
    handleLogout() {
      this.$eventHub.$emit(NOT_AUTHORIZED);
    },
  },
};
</script>
